import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';

type Props = TooltipProps<ValueType, NameType> & {
  format: string;
};
export function ScansChartTooltip(data: Props) {
  const { t } = useTranslation();
  const { active, payload, label, format } = data;

  if (!active) return null;

  return (
    <div className="px-3 py-2 bg-skapa-interactive-emphasised-bg-pressed rounded border border-neutral-200 flex flex-col text-center">
      {payload && payload.length > 1 ? (
        payload.map((item) => (
          <span
            key={String(item.dataKey ?? item.name)}
            className="text-white text-xs font-bold leading-[18px]"
          >
            {item.name ? `${item.name}: ` : `${t('label.scans')}: `}
            {item.value}
          </span>
        ))
      ) : (
        <span className="text-white text-xs font-bold leading-[18px]">
          {t('label.scans')}: {payload?.[0]?.value}
        </span>
      )}
      <span className="text-white text-xs leading-[18px]">
        {DateTime.fromMillis(label as number).toFormat(format)}
      </span>
    </div>
  );
}
